import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { useIsMobile, useResetPageScroll } from 'utils/hooks';
import { useMe } from 'utils/reduxHook';
import InAppRoutes, { pushProgressive } from 'utils/router';

import classNames from 'classnames';
import Logo from 'components/molecules/Logo';
import Button from 'components/atoms/Button';
import { getOrgUserInitials } from 'utils';
import UserMenu from './UserMenu';
import UserMenuItems from './UserMenuItems';

function Header() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const me = useMe();
  useResetPageScroll();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  useEffect(() => {
    if (mobileMenuOpen) {
      setMobileMenuOpen(false);
    }
  }, [location.pathname]);

  if (isMobile) {
    return (
      <>
        <div className="print:hidden w-full bg-white items-center flex fixed h-16 z-10 px-4 border-b border-charcoal-100">
          <div className="flex flex-row items-center justify-between w-full space-x-4">
            <Logo color="black" onClick={() => pushProgressive(InAppRoutes.Home)} />
            <div className="flex items-center">
              <div className="h-8 w-8 bg-charcoal-100 rounded-full flex items-center mr-5 justify-center text-xs font-medium text-charcoal-900 border border-primary">
                {getOrgUserInitials(me)}
              </div>
              <Button
                icon={mobileMenuOpen ? 'x' : 'menu'}
                dataDurableId="toggleMobileMenuButton"
                iconSize={24}
                className="text-black p-0"
                onClick={toggleMobileMenu}
              />
            </div>
          </div>
        </div>
        <nav
          className={classNames('p-4 overflow-x-hidden fixed bg-white w-full z-50 mt-16 h-[calc(100vh_-_137px)]', {
            block: mobileMenuOpen,
            hidden: !mobileMenuOpen,
          })}
        >
          <div>
            <UserMenuItems />
          </div>
        </nav>
      </>
    );
  }

  return (
    <div className="print:hidden w-full bg-black items-center flex fixed h-20 z-10 px-8 flex-row justify-between border-b border-charcoal-700">
      <Logo color="white" onClick={() => pushProgressive(InAppRoutes.Home)} />
      <div className="flex space-x-6 items-center">
        <UserMenu textColor="white" />
      </div>
    </div>
  );
}

export default Header;
